const AuthLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-600 to-primary-800 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-white">Hotel101</h1>
          <p className="mt-2 text-primary-200">Global Support Platform</p>
        </div>
        <div className="bg-white rounded-lg shadow-xl p-8">
          {children}
        </div>
        <p className="text-center text-primary-200 text-sm">
          Hotel101 Global Pte. Ltd. - Singapore HQ
        </p>
      </div>
    </div>
  );
};

export default AuthLayout;
